export function getWeekDays(locale = "en-GB") {
  const baseDate = new Date(Date.UTC(2017, 0, 2)); // random Monday
  const weekDays = [];
  for (let i = 0; i < 7; i++) {
    weekDays.push(baseDate.toLocaleDateString(locale, { weekday: "long" }));
    baseDate.setDate(baseDate.getDate() + 1);
  }
  return weekDays;
}

export function getCurrentDayName(locale = "en-GB") {
  const date = new Date();
  return date.toLocaleDateString(locale, { weekday: "long" });
}
